import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkles2Bold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSparkles2Bold"><Path d="M14.3564 7.5L15.9834 11.7295L16.0635 11.9365L16.2705 12.0166L20.5 13.6426V14.3564L16.2705 15.9834L16.0635 16.0635L15.9834 16.2705L14.3564 20.5H13.6436L12.0166 16.2705L11.9365 16.0635L11.7295 15.9834L7.5 14.3564V13.6426L11.7295 12.0166L11.9365 11.9365L12.0166 11.7295L13.6436 7.5H14.3564Z" fill="currentColor" stroke="currentColor"/><Path d="M7.4 3H6.6L5.6 5.6L3 6.6V7.4L5.6 8.4L6.6 11H7.4L8.4 8.4L11 7.4V6.6L8.4 5.6L7.4 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSparkles2Bold;
